import { IApplicationState } from '../../types/redux';

export function selectOfferChatOfferId(state: IApplicationState): number | null {
  return state.chatModal.offerId;
}
